export class KeyGeneratorService {
    private readonly url: string;
    
    constructor(url: string) {
        this.url = url;
    }
    
    getNewKey(): Promise<any> {
        return new Promise((resolve, reject) => {
            $.ajax({ url: this.url, type: "GET" })
                .done(resolve)
                .fail(reject);
        });
    }
}
